<ng-container *ngIf="files?.length">
    <div class="deck-container">
        <app-file-card [ngClass]="{'card-mobile-ios': device.deviceInfo.os === 'iOS'}" *ngFor="let file of files; trackBy:identify" [file]="file"
            [files]="files" [selectedFiles]="selectedFiles" [device]="device" (cardContentClicked)="openPreviewModal($event)">
        </app-file-card>
    </div>
    
    <div class="loading-container" *ngIf="(filesLoading$ | async)">
        <div class="loading-spinner-grey"></div>
    </div>
    <div class="deck-button-showmore-container" *ngIf="!(filesLoading$ | async) && preview.transfer.filesNumber > files?.length">
        <button class="deck-button-showmore" (click)="getItems()">{{ 'VIEWER_DISPLAY_MORE' | translate }}</button>
    </div>
</ng-container>